import { render, staticRenderFns } from "./CNavItem.vue?vue&type=template&id=95399b34&"
import script from "./CNavItem.vue?vue&type=script&lang=ts&"
export * from "./CNavItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports